var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Box, useTheme } from "@mui/material";
import { TestTag, getAutomationTag } from "../../common/testAutomation";
var LeaderCount = function (_a) {
    var leadersCount = _a.leadersCount, countText = _a.countText;
    var theme = useTheme();
    var totalNumberCount = leadersCount;
    return (_jsx(Box, __assign({ "data-testid": "leaderCount" }, getAutomationTag(TestTag.LeaderCount), { sx: {
            fontFamily: theme.typography.fontFamily + " Medium",
            fontWeight: 500,
            fontSize: "16px",
            padding: "4px",
        } }, { children: totalNumberCount != null &&
            "".concat(totalNumberCount, " ").concat(countText).concat(totalNumberCount == 1 ? "" : "s") })));
};
export default LeaderCount;
